var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: _vm.isMobile } },
    [
      _c(
        "v-dialog",
        {
          attrs: { "full-width": !_vm.isMobile, "max-width": "500" },
          model: {
            value: _vm.showAssignTrucksInfoDialog,
            callback: function($$v) {
              _vm.showAssignTrucksInfoDialog = $$v
            },
            expression: "showAssignTrucksInfoDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c("span", { staticClass: "title mb-3" }, [
                _vm._v("Assign Your Trucks")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n      Assign your own truck and driver to cover some or all of the remaining loads.\n\n      "
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showAssignTrucksInfoDialog = false
                        }
                      }
                    },
                    [_vm._v("\n          Got It\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.showCancelTruckInfoDialog,
            callback: function($$v) {
              _vm.showCancelTruckInfoDialog = $$v
            },
            expression: "showCancelTruckInfoDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c("span", { staticClass: "title mb-3" }, [
                _vm._v("Canceling Trucks")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n      OK. Until we have the number adjustment buddy, nothing here has any meaning any more.\n      "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                '\n      Canceling a truck "unbooks" or simply removes that truck from the schedule.\n      '
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("v-icon", { attrs: { color: "accent" } }, [_vm._v("replay")]),
              _vm._v(" "),
              _c("strong", [_vm._v("Cancel Booking.")]),
              _vm._v(" "),
              _c("em", [
                _vm._v("You still intend to backfill the canceled truck.")
              ]),
              _vm._v(
                "\n      If the customer still needs that truck, use this.\n      The load will show in the planner as needing\n      one additional truck.  If all trucks had been previously scheduled out, the load will\n      re-appear in the planning list. This truck still needs to be covered.\n      "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("v-icon", { attrs: { color: "accent" } }, [
                _vm._v("highlight_off")
              ]),
              _vm._v(" "),
              _c("strong", [_vm._v("Cancel Truck.")]),
              _vm._v(" "),
              _c("em", [_vm._v("When too many trucks were scheduled.")]),
              _vm._v(
                " If the customer\n      no longer needs that truck, use this. No further action is to be taken.\n\n      "
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showCancelTruckInfoDialog = false
                        }
                      }
                    },
                    [_vm._v("\n          Got It\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-master-detail-pane",
        {
          attrs: { selected: _vm.planningLoad },
          on: {
            reset: function($event) {
              return _vm.selectPlanningLoad(null)
            }
          }
        },
        [
          _c(
            "template",
            { slot: "master" },
            [
              _c(
                "v-load-nav-list",
                {
                  attrs: {
                    "search-prompt": "Search load groups",
                    title: "Planning (" + _vm.unassignedLoads.length + ")",
                    "accurate-since": _vm.plannedLoadsAccurateSince,
                    loads: _vm.unassignedLoads,
                    customerLoads: _vm.groupedBySponsorLoads,
                    loading: _vm.loadingPlannedLoads
                  },
                  on: {
                    "update:searchTerm": function($event) {
                      _vm.search = $event
                    },
                    refresh: _vm.getPlannedLoads
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "loadTile",
                      fn: function(ref) {
                        var idx = ref.idx
                        var load = ref.load
                        return [
                          _c(
                            "v-list-tile",
                            {
                              key:
                                "unassigned_load_" +
                                idx +
                                "_" +
                                load.listingHumanId,
                              class: {
                                "primary lighten-1": _vm.isSelectedLoad(load)
                              },
                              attrs: {
                                inactive: _vm.isSelectedLoad(load),
                                ripple: "",
                                avatar: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectPlanningLoad(load)
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: _vm.availableTruckCountColor(
                                          load
                                        ),
                                        "text-color": "white"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.planningLoadGroupAvailableTruckCount(
                                              load
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(_vm._s(_vm.loadGroupName(load)))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-sub-title",
                                    { staticClass: "text--primary" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("formatDay")(
                                              load.loadGroup.scheduledPickupTime
                                            )
                                          ) +
                                          ": " +
                                          _vm._s(load.humanId) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-sub-title", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(load.loadGroup.loadCount) +
                                        " trucks, " +
                                        _vm._s(
                                          _vm.distanceLabel(
                                            load.loadGroup.details.loadedMiles
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                    _vm._.get(load, "loadGroup.amount", false)
                                      ? _c("span", [
                                          _vm._v(
                                            ", $" +
                                              _vm._s(load.loadGroup.amount) +
                                              " each"
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider", {
                            key:
                              "unassigned_divider_" +
                              idx +
                              "_" +
                              load.listingHumanId
                          })
                        ]
                      }
                    },
                    {
                      key: "customerLoadsTile",
                      fn: function(skope) {
                        return [
                          _c(
                            "v-list-group",
                            { key: "groupedBy_" + skope.idx },
                            [
                              _c(
                                "v-list-tile",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            color: _vm.availableCustomerTruckCountColor(
                                              skope.loads
                                            ),
                                            "text-color": "white",
                                            small: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.countUnassignedTruck(
                                                  skope.loads
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-title", [
                                    _vm._v(_vm._s(skope.sponsor))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(skope.loads, function(load) {
                                return _c(
                                  "div",
                                  { key: "skope_" + load.humanId },
                                  [
                                    _c(
                                      "v-list-tile",
                                      {
                                        key: "grouped_load_" + load.humanId,
                                        class: {
                                          "primary lighten-1": _vm.isSelectedLoad(
                                            load
                                          )
                                        },
                                        attrs: {
                                          inactive: _vm.isSelectedLoad(load),
                                          ripple: "",
                                          avatar: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectPlanningLoad(load)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-list-tile-avatar",
                                          { staticClass: "pl-4" },
                                          [
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  color: _vm.availableTruckCountColor(
                                                    load
                                                  ),
                                                  "text-color": "white"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.planningLoadGroupAvailableTruckCount(
                                                        load
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-content",
                                          [
                                            _vm.loadGroupNickname(load)
                                              ? _c("v-list-tile-title", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.loadGroupNickname(
                                                          load
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-tile-sub-title",
                                              { staticClass: "text--primary" },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm._f("formatDay")(
                                                        load.loadGroup
                                                          .scheduledPickupTime
                                                      )
                                                    ) +
                                                    ": " +
                                                    _vm._s(load.humanId) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("v-list-tile-sub-title", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    load.loadGroup.loadCount
                                                  ) +
                                                  " trucks, " +
                                                  _vm._s(
                                                    _vm.distanceLabel(
                                                      load.loadGroup.details
                                                        .loadedMiles
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                              _vm._.get(
                                                load,
                                                "loadGroup.amount",
                                                false
                                              )
                                                ? _c("span", [
                                                    _vm._v(
                                                      ", $" +
                                                        _vm._s(
                                                          load.loadGroup.amount
                                                        )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-divider", {
                                      key: "load_divider_" + load.humanId
                                    })
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "subheader" },
                    [
                      _c(
                        "v-subheader",
                        {
                          staticClass: "sort-btn",
                          on: {
                            click: function($event) {
                              return _vm.toggleSort()
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "pr-2",
                              attrs: { color: "primary" }
                            },
                            [
                              _vm._v(
                                "\n              error_outline\n            "
                              )
                            ]
                          ),
                          _vm._v(
                            "\n            Unassigned Trucks (" +
                              _vm._s(
                                _vm.planningLoadGroupUnassignedTruckCount
                              ) +
                              ")\n\n            "
                          ),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            { staticClass: "pl-3", attrs: { color: "accent" } },
                            [_vm._v("\n              event\n            ")]
                          ),
                          _vm._v(" "),
                          _vm.sortDesc
                            ? _c("v-icon", { attrs: { color: "accent" } }, [
                                _vm._v(
                                  "\n              arrow_drop_down\n            "
                                )
                              ])
                            : _c("v-icon", { attrs: { color: "accent" } }, [
                                _vm._v(
                                  "\n              arrow_drop_up\n            "
                                )
                              ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "detail" },
            [
              _vm.planningLoad
                ? _c("v-planned-load-group-details", {
                    attrs: {
                      "planning-load": _vm.planningLoad,
                      loading: _vm.loadingBtn,
                      company: _vm.company
                    },
                    on: {
                      reload: function($event) {
                        return _vm.refreshLoad()
                      },
                      onFormChange: function($event) {
                        return _vm.editionFormChange($event)
                      },
                      updateLoad: function($event) {
                        return _vm.updatePlanningLoad($event, true)
                      },
                      cancelLoad: function($event) {
                        return _vm.cancelLoad($event)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a757304", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a757304","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Loads/components/PlanningTool.vue
// module id = null
// module chunks = 